import React from 'react';
import { Select } from 'antd';
var {
  Option
} = Select;
export default function SelectWithFetch(props) {
  var data = [];
  var options = data.map(d => /*#__PURE__*/React.createElement(Option, {
    key: d.value
  }, d.text));
  return /*#__PURE__*/React.createElement(Select, {
    showSearch: true // value={this.state.value}
    // placeholder={this.props.placeholder}
    // defaultActiveFirstOption={false}
    // showArrow={false}
    // filterOption={false}
    // onSearch={this.handleSearch}
    // onChange={this.handleChange}
    // notFoundContent={null}

  }, options);
}